
import { authHeader } from '../_helpers';
import { CONST } from '../_config';

export const dashboardService = {

    getMetaRespondantDetails,
    getResponseAnalytics,
    getMetaResponseAnalyticsFilter,
    getEmpFilter,
    getEmpSurveyWiseFilter,
    getSurveyResponseList,
    getClientProfile,

    createCaseStudy,
    updateCaseStudy,
    deleteCaseStudy,
    getCaseStudyList,

    getCaseStudyDetailsList,
    saveCaseStudyDetails,
    updateCaseStudyDetails,


    createRolePlay,
    updateRolePlay,
    deleteRolePlay,
    getRolePlayList,

    getRolePlayDetailsList,
    saveRolePlayDetails,
    updateRolePlayDetails,

    getInsightMailLibraryList,
    getInsightEmployeeList,
    getInsightSurveyList,

    assignInsightEmpTasks,
    getInsightEmpTaskList,

    getCaseStudyDetails,
    getRolePlayDetails,
    getMailBoxDetails,

    getMeetingLinkDetails,
    saveMeetingNotes,
    deleteMeetingNotes,

    getMeetingNotes,
    replyInsightMail,
    getInsightMailReply,
    saveInsightActivityTracking,
    getInsightEmpTaskById,
    getInsightActivityTrackingByEmpId,

    saveInsightEmployeeList,
    getInsightUser,
    updateReplyInsightMail,
    deleteReplyInsightMail,
    getConnectDetails,

    createInsightMail,
    updateInsightMail,

    updateAssignInsightEmpTasks,
    savePDFUpload,
    createInsightEmployee,
    updateInsightEmployee,
    deleteInsightEmployee,
    getInsightUploadsByAssignedId,
    getInsightSurveyByAssignedId,
    getInsightActivityStatus,
    saveInsightActivityApproval,
    getInsightUploadStatus,
    saveCoachUsers,
    getCoachUsers,
    getCoachEmployeeList,
    submitCoachFeedback,
    getInsightCompetencyList,
    getInsightAllFeedbacks,
    saveInboxIntro,
    getInsightMailLibraryIntro,
    getInsightMailReplies
};

async function getInsightMailReplies(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)
    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightMailReplies`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightMailRepliesData: data.data
            }
            return IndexObj;
        });
}


async function saveInboxIntro(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)
    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/saveInboxIntro`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                saveInboxIntroData: data.data
            }
            return IndexObj;
        });
}

async function getInsightAllFeedbacks(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)
    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightAllFeedbacks`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightAllFeedbacksData: data.data
            }
            return IndexObj;
        });
}

async function getInsightCompetencyList(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)
    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightCompetencyList`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightCompetencyListData: data.data
            }
            return IndexObj;
        });
}





async function submitCoachFeedback(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/submitCoachFeedback`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                submitCoachFeedbackData: data.data
            }
            return IndexObj;
        });
}

async function getCoachEmployeeList(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getCoachEmployeeList`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getCoachEmployeeListData: data.data
            }
            return IndexObj;
        });
}





async function saveCoachUsers(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/saveCoachUsers`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                saveCoachUsersData: data.data
            }
            return IndexObj;
        });
}


async function getCoachUsers(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getCoachUsers`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getCoachUsersData: data.data
            }
            return IndexObj;
        });
}



async function getInsightUploadStatus(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightUploadStatus`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightUploadStatusData: data.data
            }
            return IndexObj;
        });
}




async function saveInsightActivityApproval(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/saveInsightActivityApproval`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                saveInsightActivityApprovalData: data.data
            }
            return IndexObj;
        });
}





async function getInsightActivityStatus(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightActivityStatus`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightActivityStatusData: data.data
            }
            return IndexObj;
        });
}


async function getInsightSurveyByAssignedId(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightSurveyByAssignedId`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightSurveyByAssignedIdData: data.data
            }
            return IndexObj;
        });
}



async function getInsightUploadsByAssignedId(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightUploadsByAssignedId`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightUploadsByAssignedIdData: data.data
            }
            return IndexObj;
        });
}
async function deleteInsightEmployee(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/deleteInsightEmployee`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                deleteInsightEmployeeData: data.data
            }
            return IndexObj;
        });
}
async function createInsightEmployee(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/createInsightEmployee`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                createInsightEmployeeData: data.data
            }
            return IndexObj;
        });
}
async function updateInsightEmployee(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/updateInsightEmployee`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                updateInsightEmployeeData: data.data
            }
            return IndexObj;
        });
}





async function savePDFUpload(formData) {

    let header = new Headers({
        "Authorization": authHeader().Authorization
        // ❌ DO NOT set Content-Type here
    });

    const requestOptions = {
        method: "POST",
        headers: header,
        body: formData   // ✅ send directly
    };

    return fetch(
        CONST.BACKEND_EMPROLE_URL + `/savePDFUpload`,
        requestOptions
    )
        .then(handleResponse)
        .then(data => {
            return {
                savePDFUploadData: data.data
            };
        });
}


async function updateAssignInsightEmpTasks(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/updateAssignInsightEmpTasks`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                updateAssignInsightEmpTasksData: data.data
            }
            return IndexObj;
        });
}


async function createInsightMail(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/createInsightMail`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                createInsightMailData: data.data
            }
            return IndexObj;
        });
}

async function updateInsightMail(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/updateInsightMail`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                updateInsightMailData: data.data
            }
            return IndexObj;
        });
}


async function getConnectDetails(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getConnectDetails`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getConnectDetailsData: data.data
            }
            return IndexObj;
        });
}

async function deleteReplyInsightMail(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/deleteReplyInsightMail`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                deleteReplyInsightMailData: data.data
            }
            return IndexObj;
        });
}


async function updateReplyInsightMail(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/updateReplyInsightMail`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                updateReplyInsightMailData: data.data
            }
            return IndexObj;
        });
}




async function getInsightUser(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightUser`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightUserData: data.data
            }
            return IndexObj;
        });
}






async function saveInsightEmployeeList(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/saveInsightEmployeeList`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                saveInsightEmployeeListData: data.data
            }
            return IndexObj;
        });
}




async function getInsightActivityTrackingByEmpId(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightActivityTrackingByEmpId`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightActivityTrackingByEmpIdData: data.data
            }
            return IndexObj;
        });
}



async function saveInsightActivityTracking(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/saveInsightActivityTracking`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                saveInsightActivityTrackingData: data.data
            }
            return IndexObj;
        });
}



async function replyInsightMail(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/replyInsightMail`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                replyInsightMailData: data.data
            }
            return IndexObj;
        });
}

async function getInsightMailReply(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightMailReply`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightMailReplyData: data.data
            }
            return IndexObj;
        });
}

async function saveMeetingNotes(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/saveMeetingNotes`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                saveMeetingNotesData: data.data
            }
            return IndexObj;
        });
}

async function deleteMeetingNotes(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/deleteMeetingNotes`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                deleteMeetingNotesData: data.data
            }
            return IndexObj;
        });
}

async function getMeetingNotes(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getMeetingNotes`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getMeetingNotesData: data.data
            }
            return IndexObj;
        });
}


async function getMeetingLinkDetails(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getMeetingLinkDetails`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getMeetingLinkDetailsData: data.data
            }
            return IndexObj;
        });
}



async function getCaseStudyDetails(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getCaseStudyDetails`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getCaseStudyDetailsData: data.data
            }
            return IndexObj;
        });
}

async function getRolePlayDetails(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getRolePlayDetails`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getRolePlayDetailsData: data.data
            }
            return IndexObj;
        });
}


async function getMailBoxDetails(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getMailBoxDetails`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getMailBoxDetailsData: data.data
            }
            return IndexObj;
        });
}




async function assignInsightEmpTasks(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/assignInsightEmpTasks`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                assignInsightEmpTasksData: data.data
            }
            return IndexObj;
        });
}

async function getInsightEmpTaskById(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightEmpTaskById`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightEmpTaskByIdData: data.data
            }
            return IndexObj;
        });
}



async function getInsightEmpTaskList(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightEmpTaskList`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightEmpTaskListData: data.data
            }
            return IndexObj;
        });
}


async function getInsightEmployeeList(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightEmployeeList`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightEmployeeListData: data.data
            }
            return IndexObj;
        });
}

async function getInsightSurveyList(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightSurveyList`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightSurveyListData: data.data
            }
            return IndexObj;
        });
}


async function getCaseStudyDetailsList(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getCaseStudyDetailsList`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getCaseStudyDetailsListData: data.data
            }
            return IndexObj;
        });
}
async function saveCaseStudyDetails(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/saveCaseStudyDetails`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                saveCaseStudyDetailsData: data.data
            }
            return IndexObj;
        });
}
async function updateCaseStudyDetails(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/updateCaseStudyDetails`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                updateCaseStudyDetailsData: data.data
            }
            return IndexObj;
        });
}

async function getCaseStudyList(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getCaseStudyList`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getCaseStudyListData: data.data
            }
            return IndexObj;
        });
}

async function createCaseStudy(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/createCaseStudy`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                createCaseStudyData: data.data
            }
            return IndexObj;
        });
}

async function updateCaseStudy(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/updateCaseStudy`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                updateCaseStudyData: data.data
            }
            return IndexObj;
        });
}

async function deleteCaseStudy(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/deleteCaseStudy`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                deleteCaseStudyData: data.data
            }
            return IndexObj;
        });
}


//----------------------------------------------------------------------------------------------------

async function getRolePlayDetailsList(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getRolePlayDetailsList`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getRolePlayDetailsListData: data.data
            }
            return IndexObj;
        });
}
async function saveRolePlayDetails(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/saveRolePlayDetails`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                saveRolePlayDetailsData: data.data
            }
            return IndexObj;
        });
}
async function updateRolePlayDetails(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/updateRolePlayDetails`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                updateRolePlayDetailsData: data.data
            }
            return IndexObj;
        });
}
async function getInsightMailLibraryList(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightMailLibraryList`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightMailLibraryListData: data.data
            }
            return IndexObj;
        });
}

async function getInsightMailLibraryIntro(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getInsightMailIntro`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getInsightMailLibraryIntroData: data.data
            }
            return IndexObj;
        });
}



async function getRolePlayList(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/getRolePlayList`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getRolePlayListData: data.data
            }
            return IndexObj;
        });
}

async function createRolePlay(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/createRolePlay`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                createRolePlayData: data.data
            }
            return IndexObj;
        });
}

async function updateRolePlay(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/updateRolePlay`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                updateRolePlayData: data.data
            }
            return IndexObj;
        });
}

async function deleteRolePlay(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_EMPROLE_URL + `/deleteRolePlay`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                deleteRolePlayData: data.data
            }
            return IndexObj;
        });
}









async function getMetaRespondantDetails(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/getMetaRespondantDetails`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getMetaRespondantDetailsData: data.data
            }
            return IndexObj;
        });
}


async function getResponseAnalytics(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/getResponseAnalyticsFilter`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getResponseAnalyticsData: data.data
            }
            return IndexObj;
        });
}

async function getMetaResponseAnalyticsFilter(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/getMetaResponseAnalyticsFilter`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getMetaResponseAnalyticsFilterData: data.data
            }
            return IndexObj;
        });
}


async function getEmpFilter(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/getEmpFilter`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                EmpFilterData: data.data
            }
            return IndexObj;
        });
}

async function getEmpSurveyWiseFilter(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/getEmpSurveyWiseFilter`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                EmpFilterData: data.data
            }
            return IndexObj;
        });
}





async function getSurveyResponseList(value) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/getSurveyResponseList`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                getSurveyResponseListData: data.data
            }
            return IndexObj;
        });
}



async function getClientProfile(value) {
    console.log("value--1231231-", value)
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(value)

    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/getClientProfile`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let IndexObj = {
                ClientProfileData: data.data
            }
            return IndexObj;
        });
}



function handleResponse(response) {
    // //////console.log("response22222   ", response);

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logoutSession();
                //location.reload(true);
            }
            // //////console.log("datadatadata ", response);

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        ////////console.log("datadatadatadatadata   ", data.error);
        if (data.error) {
            // //////console.log("datadatadatadatadata   ", data);
            if (data.code === 3) {
                logoutSession();
            }
            if (data && data.message && (data.message === "UnauthorizedError")) {
                logoutSession()

            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}


function logoutSession(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/userlogout`, requestOptions)
        .then(user => {
            let userObj = {
                userLogout: user
            }
            localStorage.removeItem('adminuser');
            window.location.href = "#/insight/signin";
            return userObj;
        });
}





